module.exports = __webpack_public_path__ + "static/media/drumLogo.8cf3886c.png";